module.exports = __webpack_public_path__ + "img/ExCo.ab5f680c.svg";